import { useState } from "react";

const useSubmitMessages = () => {
  const [errorMsg, setErrorMsg] = useState<string>("");
  const [successMsg, setSuccessMsg] = useState<string>("");

  const clearMessages = () => {
    if (errorMsg) setErrorMsg("");
    if (successMsg) setSuccessMsg("");
  };

  return {
    errorMsg, setErrorMsg,
    successMsg, setSuccessMsg,
    clearMessages
  }
}

export default useSubmitMessages;